// src/auth/gateConfig.js
import { PLANS, NASCAR_ALL, MLB_ALL, NFL_ALL, NBA_ALL } from "./plans";

/**
 * PROMO toggles — ONLY sports routes.
 * Flip any value to true to open that section (and its subpaths) for everyone.
 * Leave non-sports paths out of here; they’re always public in the modal.
 */
export const PROMO_UNLOCKS = {
  // NASCAR PRO tools
  "/nascar/cup/optimizer": false,
  "/nascar/oreilly/optimizer": false,
  "/nascar/trucks/optimizer": false,
  "/nascar/cup/contest-simulator": false,
  "/nascar/oreilly/contest-simulator": false,
  "/nascar/trucks/contest-simulator": false,

  // NASCAR sections
  "/nascar/cup": false,
  "/nascar/oreilly": false,
  "/nascar/trucks": false,
  "/nascar": false,

  // NFL
  "/nfl/classic/optimizer": false,
  "/nfl/showdown/optimizer": false,
  "/nfl/optimizer": false,
  "/nfl": false,

  // NBA
  "/nba/optimizer": false,
  "/nba": false,

  // MLB
  "/mlb/optimizer": false,
  "/mlb": false,
};
/**
 * Rules are matched in order; first match wins.
 * - Optimizers + Contest Simulator: PRO only (plus ALL_ACCESS_PRO)
 * - Sport sections: LITE or PRO (plus ALL_ACCESS_LITE/PRO)
 *
 * NOTE: Non-sports routes (home, login, signup, pricing, account, dashboard,
 * discord, etc.) are *always* public in ProtectedByPathModal.jsx, so
 * they do not appear here.
 */
export const ROUTE_RULES = [
  /* ================= ARTICLES ================= */

  { prefix: "/nascar/cup/articles", allow: [] },

  /* ================= PRO TOOLS ================= */

  // NASCAR optimizers
  { prefix: "/nascar/cup/optimizer", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nascar/oreilly/optimizer", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nascar/trucks/optimizer", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },

  // NASCAR contest simulators
  { prefix: "/nascar/cup/contest-simulator", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nascar/oreilly/contest-simulator", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nascar/trucks/contest-simulator", allow: [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO] },

  // MLB optimizer
  { prefix: "/mlb/optimizer", allow: [PLANS.MLB_PRO, PLANS.ALL_ACCESS_PRO] },

  // NBA optimizer
  { prefix: "/nba/optimizer", allow: [PLANS.NBA_PRO, PLANS.ALL_ACCESS_PRO] },

  // NFL optimizers
  { prefix: "/nfl/classic/optimizer", allow: [PLANS.NFL_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nfl/showdown/optimizer", allow: [PLANS.NFL_PRO, PLANS.ALL_ACCESS_PRO] },
  { prefix: "/nfl/optimizer", allow: [PLANS.NFL_PRO, PLANS.ALL_ACCESS_PRO] },

  /* ================= SPORT SECTIONS ================= */

  { prefix: "/nascar", allow: NASCAR_ALL },
  { prefix: "/mlb", allow: MLB_ALL },
  { prefix: "/nfl", allow: NFL_ALL },
  { prefix: "/nba", allow: NBA_ALL },
];